/*
 * Rooana 03.11.2026: добавяне с един клик от количката и продуктовата страница
 * (комплекти и плочки „Добави към визията“).
 * Елемент [data-rooana-bundle] с <script type="application/json" data-items> и бутон [data-rooana-bundle-add].
 * Ако някой продукт има повече от един нюанс, се отваря панел със снимка и цветни кръгчета
 * (цветът се взима от снимката на нюанса — assets/rooana-pdp-swatches.js). След добавяне се отваря количката.
 */
(function () {
  if (window.__rooanaPicker) return;
  window.__rooanaPicker = true;

  function money(cents) {
    var v = ((Number(cents) || 0) / 100).toFixed(2).replace(".", ",");
    var f = window.rooanaMoneyFormat || "{{amount_with_comma_separator}} €";
    return f.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, "");
  }

  function currentVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input && input.value ? Number(input.value) : null;
  }

  function addToCart(ids) {
    var drawer = document.querySelector('cart-drawer');
    var body = {
      items: ids.map(function (id) {
        return { id: id, quantity: 1 };
      }),
    };
    if (drawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw new Error(data.description || data.message || 'add-failed');
          return data;
        });
      })
      .then(function (data) {
        if (drawer && data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ id: null, sections: data.sections });
        } else {
          window.location.href = window.routes.cart_url;
        }
      });
  }

  /* ---------- Панел за нюанс ---------- */
  var sheet, state;

  function buildSheet() {
    sheet = document.createElement('div');
    sheet.className = 'rpk';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="rpk__overlay" data-rpk-close></div>' +
      '<div class="rpk__panel" role="dialog" aria-modal="true" aria-labelledby="RpkTitle">' +
      '<div class="rpk__head"><p class="rpk__title" id="RpkTitle"></p>' +
      '<button type="button" class="rpk__close" data-rpk-close aria-label="Затвори">&times;</button></div>' +
      '<div class="rpk__items"></div>' +
      '<button type="button" class="button rpk__add" data-rpk-add></button>' +
      '<p class="rpk__error" role="alert" hidden>Не успяхме да добавим. Опитай отново.</p>' +
      '</div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-rpk-close]')) return closeSheet();
      var sw = e.target.closest('[data-rpk-variant]');
      if (sw) return pick(sw);
      if (e.target.closest('[data-rpk-add]')) return confirmSheet();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet();
    });
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function openSheet(items, onDone) {
    if (!sheet) buildSheet();
    state = { items: items, chosen: {}, onDone: onDone };
    var html = '';
    var toPick = 0;
    items.forEach(function (it, i) {
      if (it.state === 'current' || it.variants.length < 2) return;
      toPick++;
      var def = it.variants.filter(function (v) { return v.id === it.default; })[0] || it.variants[0];
      state.chosen[i] = def;
      html +=
        '<div class="rpk__item" data-rpk-item="' + i + '">' +
        '<img class="rpk__img" src="' + esc(def.img) + '" alt="" width="88" height="88">' +
        '<div class="rpk__body"><p class="rpk__name">' + esc(it.name) + '</p>' +
        '<p class="rpk__shade">Нюанс: <strong data-rpk-shade>' + esc(def.t) + '</strong></p>' +
        '<div class="rpk__shades">' +
        it.variants
          .map(function (v) {
            return (
              '<button type="button" class="rooana-shade rpk__sw' + (v.id === def.id ? ' is-on' : '') + '"' +
              ' data-rpk-variant="' + v.id + '" data-shade="' + esc(v.t) + '" data-sw-src="' + esc(v.img) + '"' +
              ' title="' + esc(v.t) + '" aria-label="' + esc(v.t) + '">' +
              '<span class="rooana-shade__dot" aria-hidden="true"></span>' +
              '<img src="' + esc(v.img) + '" alt="" loading="lazy" width="40" height="40">' +
              '</button>'
            );
          })
          .join('') +
        '</div></div></div>';
    });
    sheet.querySelector('.rpk__title').textContent = toPick > 1 ? 'Избери нюансите' : 'Избери нюанс';
    sheet.querySelector('.rpk__items').innerHTML = html;
    sheet.querySelector('.rpk__error').hidden = true;
    updateTotal();
    sheet.hidden = false;
    document.documentElement.classList.add('rpk-open');
    requestAnimationFrame(function () {
      sheet.classList.add('is-open');
    });
  }

  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('rpk-open');
    setTimeout(function () {
      sheet.hidden = true;
    }, 200);
  }

  function pick(sw) {
    var wrap = sw.closest('[data-rpk-item]');
    var i = Number(wrap.dataset.rpkItem);
    var id = Number(sw.dataset.rpkVariant);
    var v = state.items[i].variants.filter(function (x) { return x.id === id; })[0];
    if (!v) return;
    state.chosen[i] = v;
    wrap.querySelectorAll('.rpk__sw').forEach(function (b) {
      b.classList.toggle('is-on', b === sw);
    });
    wrap.querySelector('[data-rpk-shade]').textContent = v.t;
    wrap.querySelector('.rpk__img').src = v.img;
    updateTotal();
  }

  function resolveIds() {
    return state.items.map(function (it, i) {
      if (it.state === 'current') return currentVariantId() || it.default;
      if (state.chosen[i]) return state.chosen[i].id;
      return it.default;
    });
  }

  function updateTotal() {
    var total = 0;
    state.items.forEach(function (it, i) {
      var v = state.chosen[i] || it.variants.filter(function (x) { return x.id === it.default; })[0] || it.variants[0];
      if (v) total += v.p;
    });
    sheet.querySelector('[data-rpk-add]').textContent = 'Добави · ' + money(total);
  }

  function confirmSheet() {
    var btn = sheet.querySelector('[data-rpk-add]');
    btn.disabled = true;
    btn.classList.add('loading');
    addToCart(resolveIds())
      .then(function () {
        btn.disabled = false;
        btn.classList.remove('loading');
        closeSheet();
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.classList.remove('loading');
        sheet.querySelector('.rpk__error').hidden = false;
        console.error('[rooana-picker]', err);
      });
  }

  /* ---------- Бутоните ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rooana-bundle-add]');
    if (!btn) return;
    var root = btn.closest('[data-rooana-bundle]');
    if (!root) return;
    var items;
    try {
      items = JSON.parse(root.querySelector('script[data-items]').textContent);
    } catch (err) {
      console.error('[rooana-picker] bad data', err);
      return;
    }
    var needs = items.some(function (it) {
      return it.state !== 'current' && it.variants.length > 1;
    });
    if (needs) {
      openSheet(items);
      return;
    }
    btn.disabled = true;
    btn.classList.add('loading');
    var errEl = root.querySelector('.rso__error');
    addToCart(
      items.map(function (it) {
        return it.state === 'current' ? currentVariantId() || it.default : it.default;
      })
    ).catch(function (err) {
      btn.disabled = false;
      btn.classList.remove('loading');
      if (errEl) errEl.hidden = false;
      console.error('[rooana-picker]', err);
    });
  });
})();
